const gameRU = {
    changeDay: {
        header: "Новый День",
        link: "Ты слышишь звук будильника..."
    },

    endDidntPayRent: "<1>ПЛОХАЯ КОНЦОВКА. Не можешь заплатить за аренду</1>" +
        "<2/>" +
        "Арендодатель долго кричал на тебя, а потом просто взял и выселил.\n" +
        "Вы c <3>wife</3> переехали сначала к её родителям, а потом всё пошло наперекосяк и там.\n" +
        "В итоге <3>wife</3> развелась с тобой, а ты после долгих скитаний от мотеля к мотелю оказался в итоге на улице.\n\n" +
        "<4>Начать сначала</4>",

    endBadRelationsWithWife: "<1>ПЛОХАЯ КОНЦОВКА. Плохие отношения с {{wife}}</1>" +
        "<2/>" +
        "Ты проснулся с утра и застал <3>wife</3>, собирающую свои вещи в чемоданы." +
        "<4>{{wife}}, ты чего делаешь?</4>" +
        "<5>Собираю свои вещи и переезжаю к родителям.</5>" +
        "<4>В смысле? Что ты такое говоришь???</4>" +
        "<5>В прямом смысле, {{player}}, я устала всё это терпеть.</5>" +
        "<4>Подожди, давай обсудим всю ситуацию и...</4>" +
        "<5>Нет, {{player}}, нам уже нечего обсуждать.</5>\n\n" +
        "...\n\n" +
        "<6>Начать сначала</6>",

    playAsNow: "<1>Ты играешь за {{name}} сейчас.</1>" +
        "<2>Продолжить</2>",

    courierJob: {
        e01: "<1>Работа...</1>" +
            "<2/>" +
            "Ты проводишь время в дороге, развозя заказы покупателям. Ничего интересного не происходит. В принципе, как всегда на этой работе.",
        e02: "Рабочий день закончен.\n\n" +
            "<1>Вернуться домой</1>",
        e03: "<1>Вернуться на склад за очередной партией товара</1>"
    },

    courierJobEventMoto: "<1>Работа...</1>" +
        "Ты спокойно ехал по пути одного из заказов, когда тебя начал обгонять мотоциклист. " +
        "Ты сначала не обратил на него внимания, но потом заметил, что сзади его сидела девушка в юбке. Ветер то и дело сдувал юбку с её шикарной попки." +
        "<2/>" +
        "Под юбкой были очень открытые стринги, под которыми ты заметил... анальную пробку?\n" +
        "Поддав газа, ты какое-то время еще понаблюдал эту картину, но потом мотоцикл окончательно отдалился. Тогда ты понял, что у тебя встал член.\n\n" +
        "<3>Поехать дальше</3>",

    courierJobEventCar: "<1>Работа...</1>" +
        "Ты стоял в центре города в пробке у одного из светофоров. Замечтавшись, ты перестал за собой следить, а когда очнулся, то понял, что " +
        "твой взгляд сверлит девушку-водителя, которая сидит в соседней машине. Она тоже смотрела на тебя. Когда ты осознал это, то сразу перевёл взгляд. " +
        "Но что-то в этой девушке тебя, видимо, зацепило, поэтому через какое-то время ты снова перевёл на неё глаза. Она всё еще смотрела на тебя и улыбалась.\n" +
        "Ты снова отвёл глаза, а потом снова посмотрел на девушку. Тогда она неожиданно показала тебе знак рукой, который означал \"1 момент\", а дальше она..." +
        "<2/>" +
        "А дальше она просто взяла и показала тебе свою великолепную грудь. От увиденного, ты чуть не въехал в автомобиль, который стоял впереди тебя. " +
        "А когда посмотрел назад на девушку, она оказалась уже впереди тебя на две машины. Твой член стоял и он командовал тебе догнать ту девушку.\n" +
        "Но в пробке этого так и не получилось сделать, поэтому ты решил поехать дальше.\n\n" +
        "<3>Поехать дальше</3>",

    courierJobEventDelivery: "<1>Работа...</1>" +
        "Ты поднялся с товаром в одну из квартир, не ожидая ничего необычного, затем позвонил в звонок. " +
        "Через несколько мгновений дверь открыла молодая девушка лет 20. Из одежды на ней было только белое нижнее бельё. " +
        "Ты сразу отвёл взгляд, отдал ей товар и попросил оплату, всё так же не смотря на неё." +
        "<2>Войдите, пожалуйста, я не хочу, чтобы меня все видели в таком виде.</2> Сказала она.\n" +
        "Ты согласился и прошёл в квартиру. Но вместо оплаты, тебя там ждал немного другой сюрприз..." +
        "<3/>" +
        "Девушка медленно начала снимать лифчик." +
        "<2>Может быть по-другому расплачусь?</2> Ты застыл, как вкопанный и пришел в сознание только тогда, когда она начала к тебе подходить." +
        "<4>Нет, мадам... эмм... мисс... Я бы с удовольствием... Но по регламенту я не имею права...</4> Девушка такого ответа не ожидала.\n" +
        "Она на секунду растерялась, потом прикрыла грудь руками и пошла за деньгами.\n" +
        "Когда она вернулась, на ней был уже халат." +
        "<2>Вот, сдачи не нужно.</2>" +
        "<4>Спасибо, мисс....</4> Сказал ты и начал нащупывать рукой дверь сзади себя. Через минуту ноги твоей уже не было на этаже. В лифте ты схватил рукой член - он стоял.\n\n" +
        "<5>Поехать дальше</5>",

    courierJobEventDelivery1: "<1>Работа...</1>" +
        "Ты с очередной посылкой приехал в ближайший пригород и позвонил в звонок в один из домов. Дверь открыла тебе девушка " +
        "с темными волосами 25-лет и... в одних трусах и топике. Она пригласила тебя войти, но ты вошел только в коридор и на этом остановился. " +
        "Ты отдал ей посылку и не контролируя себя начал пялиться на её нижнее бельё. Она тоже не спешила уходить. Затем всё таки поставила " +
        "доставленный тобой пакет и направилась за деньгами. Трусы оказались стрингами и на тебя сейчас смотрели две идеальные половинки её " +
        "задницы. Взгляд твой был прикован только к ним." +
        "<2/>" +
        "Хозяйка исчезла из поля твоего зрения, и появилась в нём только через несколько минут. Иииии... она была без трусов, но " +
        "при этом протягивала тебе деньги за доставку. Их ты, конечно, не сразу заметил, так как пялился на её идеально выбритую пизду. " +
        "Только когда она подошла к тебе и сказала:" +
        "<3>Можете потрогать, если хотите.</3>" +
        "Сразу после этого ты очнулся, ответил ей отрицательно, забрал деньги и быстро вышел за дверь. В трусах был огромный стояк.\n" +
        "Кажется, в твоей работе всё-таки есть кое-какие плюсы...\n\n" +
        "<4>Поехать дальше</4>",

    courierJobEventDelivery2: "<1>Работа...</1>" +
        "Ты поднялся к очередной клиентке, которая жила на окраине города.\n" +
        "Когда подошел к двери, хотел позвонить в звонок, но увидел, что дверь была приоткрыта. Так часто делали клиенты, особенно при " +
        "безналичном способе оплаты посылок. Но обязательно нужно было дать знать о себе, чтобы человек знал, что курьер приехал.\n" +
        "Поэтому когда ты вошел внутрь и не обнаружил ни одного человека в коридоре, ты крикнул, что приехал курьер. Но " +
        "ответа не последовало. Постояв так минуты две, ты начал различать из ближайшей комнаты какие-то звуки. Тогда ты решил подойти туда" +
        "и позвать хозяина.\n Подойдя, ты увидел следующую картину: девушка лежала на кровати и мастурбировала." +
        "<2/>" +
        "Посмотрев немного на эту прелесть и немного замечтавшись, ты тихонько прикрыл дверь, а потом постучал в неё и громко сказал \"Курьер\". " +
        "Послышались какие-то резкие движения и девушка крикнула в ответ \"Хорошо, спасибо, не заходите только сюда!\". Ты ехидно улыбнулся, но " +
        "ответил \"Хорошо, всего хорошего!\", после чего удалился из квартиры. В штанах ты ощущал стояк.\n\n" +
        "<3>Поехать дальше</3>",

    courierJobEventDelivery3: "<1>Работа...</1>" +
        "Ты доставлял очередной товар в квартиру в одном из центральных районов города. Товар был достаточно тяжелым, поэтому ты еле дотащил его на третий этаж.\n" +
        "Дверь открыл худой мужчина лет сорока." +
        "<2>Добрый день.</2> Сказал он и отошел в сторону, пропуская тебя войти.\n" +
        "Ты с этой большой коробкой еле вошел к ним в дверь. А войдя, сразу поставил её на пол." +
        "<2>А вы можете её, пожалуйста отнести в дальнюю комнату? А то она очень тяжелая.</2>" +
        "<3>Хорошо, сейчас только переведу дыхание...</3> Сказал ты, мысленно посылая его куда подальше.\n" +
        "Вдруг в соседней комнате зазвонил телефон. Мужчина встрепенулся и побежал брать трубку, крикнув тебе:" +
        "<2>Мне по работе нужно срочно ответить. Отнесите пожалуйста в самую дальнюю по коридору.</2>" +
        "Ты снова в голове послал его далеко. " +
        "Но немного отдышавшись взял коробку и потащил её по коридору. Справа и слева были открыты двери, куда ты особо не заглядывал, пытаясь сосредоточиться на коробке.\n" +
        "В итоге ты чуть-ли не бросил её на пол возле кровати. \"Всё, пошёл на хуй, я ему еще должен что-то таскать.\" " +
        "С этими мыслями ты пошел обратно. Но по пути твой взгляд упал на одну из комнат, на которые до этого ты не обращал внимания. " +
        "Это оказалась ванная комната, в ней стояла девушка и... играла с вибратором..." +
        "<4/>" +
        "Ты остановился и начал смотреть на эту картину. С каждой минутой ты всё более возбуждался, а она всё ближе подходила к оргазму...\n" +
        "Ты опомнился только тогда, когда девушка кончила и вся затряслась. Тогда ты взял себя в руки и продолжил движение по направлению к выходу.\n\n" +
        "<5>Поехать дальше</5>",

    courierJobEventStairs: "<1>Работа...</1>" +
        "Ты доставлял очередную посылку в одну из квартир в один из периферийных кварталов города. " +
        "Подойдя к подъезду дома по адресу, ты чуть было не столкнулся лицо к лицу с девушкой, которая тоже шла в подъезд." +
        "<2>Простите, пожалуйста, проходите.</2> Сказал ты, немного опешив." +
        "<3>Благодарю вас.</3> Ответила девушка, как будто ничего и не случилось." +
        "Девушка была с темными волосами, завязанными косой, в майке, из-под которой торчал черный лифчик и в коротких шортах.\n" +
        "Когда ты пошел за ней по лестнице, естественно, смотреть ты никуда не мог, кроме её задницы." +
        "<4/>" +
        "В итоге после нескольких пролетов ваши пути разминулись и ты успешно доставил посылку.\n\n" +
        "<5>Поехать дальше</5>",

    courierJobEventStore: "<1>Работа...</1>" +
        "Во время одной из поездок ты понял, что проголодался и решил заехать в один из супермаркетов, которые находятся в северной части города.\n" +
        "Ты вошел внутрь и шел в отдел готовой еды, как твой взгляд упал на девушку в большой черной шляпе и короткими джинсовыми шортами. " +
        "Она стояла к тебе раком, нагнувшись за какими-то конфетами на первой полке. Ты был не в силах выдержать такой великолепной картины, " +
        "поэтому невольно остановился и даже сделал несколько шагов назад, чтобы лучше рассмотреть задницу девушки. А задница была высшего качества." +
        "<2/>" +
        "Ты любовался ей, забыв о всяких нормах приличия. Поэтому когда девушка выпрямилась и посмотрела на тебя, ты продолжил смотреть на её задницу.\n" +
        "Вскоре ты очнулся и заметил, что девушка в ответ пялится на тебя и улыбается. Ты весь покраснел, но ей было всё равно. " +
        "Она поняла, что ты наслаждаешься видом её задницы, но не стала тебе ничего говорить. Вместо этого она пошла в твою сторону и... оголила еще и " +
        "грудь, показав её только тебе. У тебя в штанах выпирал огромный стояк.\n" +
        "Потом девушка снова улыбнулась тебе и прошла в другой отдел. Ты посмотрел на свой стояк и поправил его. Через некоторое время ты был уже на кассе.\n\n" +
        "<3>Поехать дальше</3>",

    courierGoHome: "<1>Возвращаясь домой с работы</1>" +
        "<2/>" +
        "Уставший и недовольный ты возвращаешься домой с работы.\n\n" +
        "<3>Приехали</3>",

    courierJobOffice: "<1>Офис</1>" +
        "<2/>" +
        "Обычное небольшое офисное помещение при большом складе.\n" +
        "Сейчас ты тут никого не знаешь, и делать тебе тут нечего.\n\n" +
        "<3>Вернуться назад</3>",

    courierJobOfficeWorker: "<1>Привет, как дела? Всё ок?</1>" +
        "<2>Да, всё хорошо, спасибо.</2></4></4>" +
        "<3>Отойти</3>",

    courierJobOfficeWorkerAsWife: "<1>wife</1> и <2>worker</2> посидели и немного поболтали о всяких пустяках.\n\n" +
        "<3>Назад</3>",

    courierJobOfficeColleaguesAsWife: "<1>Офис</1>" +
        "<2/>" +
        "<3>wife</3> немного пообщалась с коллегами из офиса.\n\n" +
        "<4>Назад</4>",

    courierJobOfficeWifeDoNotDisturb: "<1>Пожалуйста, {{player}}, не отвлекай меня, я работаю...</1>" +
        "<2>Окей, прости, малыш.</2><4/><4/>" +
        "<3>Назад</3>",

    courierJobOfficeWorkerStart: "<1>Какой-то парень в офисе</1>" +
        "Ты вошел в офисное помещение и сделал пару неубедительных шагов в сторону его работников. " +
        "Поняв, что никто тебя даже не замечает, ты уже более уверенным шагам подошел к столам. Работников почему-то почти не было, кроме одного, к которому ты и подошел." +
        "<2>Эммм... привет...</2> Чувак не поднял на тебя голову и продолжал смотреть в компьютер, как будто ничего и не было.\n" +
        "Тогда ты сказал громче:" +
        "<2>Привет!</2> Чувак вздрогнул и посмотрел на тебя. Это был молодой человек лет 30 с большим острым носом и кудрявыми коричневыми волосами." +
        "<3/>" +
        "<4>Да, простите, вам что-то нужно?</4>" +
        "<2>Да, еще раз привет... Меня зовут {{player}}, я у вас тут работаю курьером внизу.</2>" +
        "<4>Привет, {{player}}, я {{worker}}, я тут занимаюсь кадрами. Я чем-то могу тебе помочь?</4>" +
        "\"Вот так удача, с первого раза и прямо в яблочко!\" - Подумал ты." +
        "<2>Я думаю, как раз вас я и искал. Понимаете, тут такая ситуация...</2>" +
        "<4>Простите, что перебиваю. Я не знаю, как вы общаетесь там внизу, но у нас все тут на \"ты\". Не возражаете, если мы тоже перейдем на \"ты\"?</4>" +
        "<2>Да, конечно... Эм, ну вот. Такая ситуация. У меня жена сейчас ищет работу и она сказала, что увидела в интернете вакансию в наш офис...</2>" +
        "<4>Да, у нас есть пара вакансий. Кто твоя жена?</4> Ты замешкался снова." +
        "<2>Её зовут {{wife}}.</2>" +
        "<4>Да нет! Кто твоя жена по профессии? И на какую она вакансию претендует?</4>" +
        "<2>Она недавно только закончила колледж по специальности дизайнера, но к нам хочет на вакансию офис-менеджера.</2>" +
        "<4>Да... немного странный выбор. А почему именно на офис менеджера? Там небольшая зарплата.</4>" +
        "<2>Для старта хорошая должность и деньги.</2> <5>worker</5> отвёл глаза обратно на компьютер." +
        "<4>Хорошо, если она не передумает, то дай ей вот этот телефон, пусть позвонит и мы договоримся о встрече.</4>" +
        "Он достал из своей сумку визитку и протянул её тебе." +
        "<2>Хорошо, спасибо...</2> Ты взял визитку и собирался уже уходить, как <5>worker</5> сказал:" +
        "<4>А у тебя как там внизу дела? Всё хорошо?</4>" +
        "<2>Да, всё хорошо, спасибо.</2>" +
        "<4>Хорошо, рад слышать. Ну если будут какие-либо проблемы или вопросы, приходи, поболтаем.</4>" +
        "<2>Хорошо, спасибо.</2> Ты повернулся и пошёл в сторону лестницы на склад.\n\n" +
        "<6>Спуститься</6>",

    playComputer: "<1>Компьютерные игры</1>" +
        "<2/>" +
        "Ты развлекаешься, играя в компьютерные игры.\n\n" +
        "<3>Завершить</3>",

    watchPorn: "<1>Порно</1>" +
        "<2/>" +
        "Ты расслабляешься, смотря порно. В штанах у тебя начинает что-то шевелиться.\n\n" +
        "<3>Завершить</3>",

    dontGoOutsideAtNight: "<1>Слишком поздно</1>" +
        "<2/>" +
        "Ты не хочешь выходить на улицу, так как уже очень поздно, и ты хочешь спать.\n\n" +
        "<3>Вернуться назад</3>",

    cantGoToBathroom: "<1>Не пойду туда</1>" +
        "<2/>" +
        "Ты не хочешь заходить в ванную, так как там моется <3>wife</3>." +
        "<4>{{wife}} отношения > {{relations}}.</4><5/><5/>" +
        "<6>Вернуться назад</6>",

    dontGoToWork: "<1>Прогул работы</1>" +
        "<2/>" +
        "Ты вышел на улицу, понимая, что пропустил сегодняшнюю рабочую смену.\n\n" +
        "<3>Да и черт с ним!</3>",

    pillsInstruction: {
        header: "<1>Инструкция к таблеткам</1>",
        body: "<1>Описание</1>" +
            "Капсулы твердые желатиновые №1. Корпус белого цвета, крышечка желтого цвета. Содержимое капсул - смесь, содержащая " +
            "гранулы и порошок от белого до белого с зеленовато-желтоватым или кремоватым оттенком цвета." +
            "<1>Показания к применению</1>" +
            "Препарат предназначен для употребления лицам строго старше 21 года. " +
            "Терапия Обсессивно-компульсивных расстройств, а именно навязчивых страхов не связанных в данный момент с содержанием " +
            "сознания и воспринимаемых больными как эмоционально неприятных." +
            "<1>Противопоказания</1>" +
            "Повышенная чувствительность к умифеновиру или любому компоненту препарата; возраст до 21 года. Первый триместр " +
            "беременности. Период грудного вскармливания. Синоатриальная блокада. Нестабильная или острая сердечная недостаточность. " +
            "Наличие искусственного водителя ритма, работающего в режиме постоянной стимуляции. Нестабильная стенокардия.\n" +
            "Эффект от применения имеет постоянный характер. Для блокирования каких-либо побочных эффектов необходимо связаться с " +
            "производителем и уточнить наличие блокирующих средств.\n" +
            "С осторожностью: \n" +
            "Второй и третий триместры беременности." +
            "<1>Способ применения и дозы</1>" +
            "Растворить препарат в любой жидкости в объеме 200МЛ, принимать до приёма пиши." +
            "<1>Побочное действие</1>" +
            "Применение препарата изучалось в исследованиях с участием почти 45 000 пациентов. Наиболее часто побочные эффекты " +
            "ивабрадина, изменения световосприятия (фосфены) и брадикардия, носили дозозависимый характер и были связаны с " +
            "механизмом действия препарата.\n" +
            "Частота побочных реакций, которые были отмечены в клинических исследованиях, приведена в виде следующей градации: " +
            "очень часто (>1/10); часто (>1/100, <1/10); нечасто (>1/1000, <1/100); редко (>1/10 000, <1/1000); очень редко " +
            "(<1/10 000); неуточненной частоты (частота не может быть подсчитана по доступным данным)." +
            "<2>Возможны изменения в поведении субъекта применения лекарственного средства, так же могут быть затронуты неожиданные сферы жизнедеятельности.</2>" +
            "<1>Производитель</1>" +
            "<3>ChainPharmOPS Corp</3>, 225 S 3rd St, Santa Marta, NM 88435\n" +
            "Phone: 555-2368 (phone, fax)\n" +
            "E-mail: help@chain.ph, site: www.chain.ph\n",
        link: "<1>Назад</1>"
    },

    sleep: "<1>Ночной сон</1>" +
        "<2/>" +
        "Ты сильно замотался за день и практически сразу вырубился.\n\n" +
        "<3>Спать</3>",

    nap: "<1>Немного подремать</1>" +
        "<2/>" +
        "Ты прилег на кровать и прикрыл глаза. Не заметил, как задремал и проснулся только через час.\n\n" +
        "<3>Встать</3>"
};

export default gameRU;